module.exports = __webpack_public_path__ + "content/2a42b8b96d7e4a077f3eda82a534862f.png";